import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'HelloWorld',
    component: HelloWorld,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/OnlineExaminationQuestion',
    name: 'OnlineExaminationQuestion',
    component: () => import('@/pages/OnlineExaminationQuestion/index'),
    meta: {
      title: '在线考试'
    }
  },
  {
    path: '/DemoQuestions',
    name: 'DemoQuestions',
    component: () => import('@/pages/DemoQuestions/index'),
    meta: {
      title: '考试演示'
    }
  },
  {
    path:'/SpecializedSkillsExamination',
    name:'SpecializedSkillsExamination',
    component: () => import('@/pages/SpecializedSkillsExamination/index'),
    meta:{
      title:'专项考试'
    }
  }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js